const TemplateList = {
    DEFAULT_FONT_PARAMETERS: {

    },
    DEFAULT_ANALYTICS_PARAMETERS: {
        dateField: "date",
        fields: ["sentiment"],
        limit: 20,
        minCount: 1,
        missing: true
    },
    STATUS: {
        SUCCESS: "SUCCESS", 
        FAILED: "FAILED"
    },
    DOCUMENT_ELEMENTS: [
        "DOCUMENT_TITLE",
        "DOCUMENT_DOMAIN",
        "DOCUMENT_AUTHOR",
        "DOCUMENT_URL",
        //"DOCUMENT_TYPE",
        "DOCUMENT_SENTIMENT",
        //"DOCUMENT_LOCATION",
        "DOCUMENT_DATE",
        "DOCUMENT_COVERAGE",
        "DOCUMENT_TAGS",
        "DOCUMENT_TEXT",
        "DOCUMENT_NUMERATION",
    ],
    FONTS_LIST: [
        '',
        'Arial',
        'Arial Black',
        'Calibri',
        'Comic Sans MS',
        'Courier New',
        'Georgia',
        'Impact',
        'Lucida Console',
        'Lucida Sans Unicode',
        'Mangal',
        'Monserrat',
        'Microsoft Sans Seri',
        'MS Outlook',
        'Roboto',
        'Rubik',
        'Segoe U',
        'Tahoma',
        'Ubuntu Mono',
        'Ubuntu Mono Medium',
        'Tahoma',
        'Times New Roman',
        'Verdana'
    ],
    TEXT_REPRESENTATION_LIST: [
        "",
        "HIGHLIGHTED_FULL_TEXT", 
        "PLAIN_FULL_TEXT", 
        "HIGHLIGHTED_FRAGMENTS"
    ],
    GROUPING_TYPE_LIST: [
        "",
        'BY_SENTIMENT',
        'BY_MEDIA_TYPE',
        'BY_DOMAIN',
        'NO_GROUPING',
        //'BY_TAGS',
        'BY_SENTIMENT_AND_MEDIA_TYPE',
        'BY_MEDIA_TYPE_AND_SENTIMENT',
        //'BY_SUBTOPICS'
    ],
    DATE_FIELDS: [
        "",
        "date",
        "updated",
        "modified"
    ],
    FIELDS_LIST: [
        {
            name: 'sentiment',
            list: 'sentiment'
        },
        {
            name: 'media_type',
            list: "media_type",
        },
        {
            name: 'media_scale',
            list: "media_scale"
        },
        /*,{
            name: 'media_place_location_id',
            list: "media_place_location_id"
        },
        {
            name: "common_location_id",
            list: "common_location_id"
        },
        {
            name: 'common_location_cty_id',
            list: "common_location_cty_id"
        },
        {
            name: 'common_location_region_id',
            list: "common_location_region_id"
        },*/
        {
            name: 'common_location_country_id',
            list: 'common_location_country_id',
        },
        /*{
            name: 'common_location_ids',
            name: 'common_location_ids'
        },*/
        {
            name: 'domain',
            list: 'domain',
        },
        {
            name: 'language',
            list: 'language'
        },
        /*{
            name: 'profile_url',
            list: "profile_url"
        },
        {
            name: 'profile_screen_name',
            list: 'profile_screen_name',
        },
        {
            name: 'profile_gender',
            list: "profile_gender"
        },
        {
            name: 'profile_type',
            list: 'profile_type',
        },*/
        {
            name: 'author',
            list: "author"
        },
        {
            name: 'type',
            list: "type"
        },
        /*{
            name: 'verification_status',
            list: "verification_status"
        },
        {
            name: "tags",
            list: "tags"
        },*/
        {
            name: "keywords",
            list: "keywords"
        },
        /*{
            name: "hashtags",
            list: "hashtags"
        },
        {
            name: "urls",
            list: "urls"
        },
        {
            name: "reasons",
            list: "reasons"
        },
        {
            name: "signatures",
            list: "signatures"
        },
        {
            name: "cluster_id",
            list: "cluster_id"
        },
        {
            name: "ratings",
            list: "ratings"
        }*/
    ],
    COLORS_LIST: {
        none: "",
        white: "ffffff",
        lightgray: "cbcbcb",
        gray: "929292",
        darkgray: "515151",
        black: "000000",
        olive: "968d00",
        brown: "bf7f40",
        orange: "ff7f00",
        red: "ff0000",
        purple: "bf0040",
        magenta: "ec008c",
        violet: "7f007f",
        blue: "0000ff",
        teal: "007e81",
        cyan: "00aeef",
        green: "00ff00",
        lime: "bfff00",
        yellow: "fff200",
        pink: "ffbfbf"
    },
    INCLUDE_TOC_LIST: [
        {
            name: "",
            list: "",
        },
                {
            name: "ON",
            list: true,
        },
                {
            name: "OFF",
            list: false,
        },
    ],
    FEED_SETTINGS: {
        documentGap: true,
        icons: true,
        documentTitle: ["DOMAIN", "TITLE"]
    }
}

export default TemplateList;